import {
  Type,
  Hash,
  List,
  CheckSquare,
  Calendar,
  User,
  Link,
  Mail,
  Phone,
  Paperclip,
  Clock,
  UserCheck,
  ListChecks,
  LucideIcon,
} from "lucide-react";

type PropertyType =
  | "title"
  | "text"
  | "number"
  | "select"
  | "multi_select"
  | "checkbox"
  | "date"
  | "person"
  | "url"
  | "email"
  | "phone"
  | "files"
  | "status"
  | "created_time"
  | "created_by"
  | "last_edited_time"
  | "last_edited_by";

interface PropertyIconProps {
  type: PropertyType;
  size?: number;
  className?: string;
}

const iconMap: Record<PropertyType, LucideIcon> = {
  title: Type,
  text: Type,
  number: Hash,
  select: List,
  multi_select: ListChecks,
  checkbox: CheckSquare,
  date: Calendar,
  person: User,
  url: Link,
  email: Mail,
  phone: Phone,
  files: Paperclip,
  status: List,
  created_time: Clock,
  created_by: UserCheck,
  last_edited_time: Clock,
  last_edited_by: UserCheck,
};

export function PropertyIcon({
  type,
  size = 14,
  className = "",
}: PropertyIconProps) {
  const Icon = iconMap[type] || Type;

  return <Icon size={size} className={`text-neutral-500 ${className}`} />;
}

export { type PropertyIconProps, type PropertyType };
